<div class="h-30"></div>
<form>
  <div class="form-fields">
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Course Name</mat-label>
      <input matInput class="form-control-textbox" [(ngModel)]="course.courseName" name="name" />
    </mat-form-field>
    @if (isSubmitted && (course.courseName === null || course.courseName === undefined || course.courseName === '')) {
      <mat-error class="validation-error"
        >Course
      Name is required</mat-error>
    }
  </div>
  <div class="mb-10"></div>

  <div class="form-fields">
    <mat-form-field>
      <mat-label>Programs</mat-label>
      <mat-select placeholder="Select Programs" name="courseprograms" multiple [(value)]="selectedPrograms"
        (selectionChange)="onProgramSelectionChange()">
        <mat-select-trigger>
          <div class="selected-pills">
            @for (prog of selectedPrograms; track prog) {
              <span class="pill" [hidden]="!(getProgramNames(prog)!=='')">
                <span>{{ getProgramNames(prog).replace(',','') }}</span>
              </span>
            }
          </div>
        </mat-select-trigger>
        @for (program of coursePrograms; track program) {
          <mat-option [value]="program.id" [disabled]="hasEnrolledUsers && isOptionDisabledForCoursePrograms(program.id)">
            {{ program.programName }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (isSubmitted && course.coursePrograms.length==0) {
      <mat-error class="validation-error">Programs are
      required</mat-error>
    }
  </div>
  <div class="mb-10"></div>

  <!-- <div class="form-fields">
  <label>Course Description</label>
  <div [froalaEditor] [(froalaModel)]="course.courseDescription"></div>

</div>
<div class="clear"></div> -->

<div class="form-fields">
  <label>Course Description</label>
  <textarea id="summernoteEditor"></textarea>
  @if (isSubmitted && (course.courseDescription === null || course.courseDescription === undefined || course.courseDescription === '')) {
    <mat-error class="validation-error">Course Description is required</mat-error>
  }
</div>
<div class="h-30"></div>

<div class="form-fields">
  <mat-form-field appearance="outline" floatLabel="always">
    <mat-label>Short Description</mat-label>
    <input matInput class="form-control-textbox" [(ngModel)]="course.courseShortDescription" name="shortDescription" />
  </mat-form-field>
  @if (isSubmitted && (course.courseShortDescription === null || course.courseShortDescription === undefined || course.courseShortDescription === '')) {
    <mat-error class="validation-error"
      >Course
    Short Description is required</mat-error>
  }
</div>
<div class="mb-10"></div>

<div class="form-fields">
  <mat-form-field appearance="outline" floatLabel="always" >
    <mat-label>Course Type</mat-label>
    <mat-select name="courseType" placeholder="Select Type" [(ngModel)]="course.courseType" required [compareWith]="compareCourseType">
      @for (ct of courseTypes; track ct) {
        <mat-option [value]="ct.id">
          {{ct.description}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
<div class="mb-10"></div>

<div class="form-fields">
  <mat-form-field appearance="outline" floatLabel="always" >
    <mat-label>Course Language</mat-label>
    <mat-select placeholder="Select Language" name="courselanguage" [(ngModel)]="course.languageId" required [disabled]="hasEnrolledUsers">
      @for (cl of courseLanguage; track cl) {
        <mat-option [value]="cl.id">
          {{cl.description}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  @if (isSubmitted && course.languageId ==0) {
    <mat-error class="validation-error">Language is required</mat-error>
  }
</div>
<div class="mb-10"></div>

<div class="form-fields">
  <mat-form-field>
    <mat-label>Tags</mat-label>
    <mat-select placeholder="Select Tags" name="coursetags" multiple [(value)]="selectedTags" [(ngModel)]="selectedTags"
      (selectionChange)="onTagSelectionChange()">
      <mat-select-trigger>
        <div class="selected-pills">
          @for (tag of selectedTags; track tag) {
            <span class="pill">
              {{ getTagNames(tag).replace(',','') }}
            </span>
          }
        </div>
      </mat-select-trigger>
      @for (tag of tags; track tag) {
        <mat-option [value]="tag.id">
          {{ tag.tagName }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  @if (isSubmitted && course.tagId.length==0) {
    <mat-error class="validation-error">Tags are required</mat-error>
  }
</div>
<div class="mb-10"></div>

<div class="material-upload-section">
  <div class="material-upload-title">Course Thumbnail Image</div>
  <ngx-dropzone (change)="onSelect($event)" [multiple]="false" [disabled]="isUploading" [hidden]="isUploading || !(course.courseThumbnailFileId == 0)">
    <ngx-dropzone-label>
      {{selectedFileName}}
    </ngx-dropzone-label>
  </ngx-dropzone>

  @if (isUploading) {
    <div class="upload-progress-card" [class.upload-complete]="isUploadComplete">
      <div class="upload-progress-header">
        <span class="upload-file-name">{{ selectedFileName }}</span>
        <span class="upload-percent">{{ uploadProgress }}%</span>
      </div>
      <div class="upload-progress-track">
        <div class="upload-progress-fill" [style.width.%]="uploadProgress"></div>
      </div>
      <p class="upload-progress-label">{{ isUploadComplete ? 'Uploaded successfully!' : 'Uploading thumbnail...' }}</p>
    </div>
  }

  @if (!isUploading && course.courseThumbnailFileId != 0) {
    <div class="uploaded-file-card">
      <div class="uploaded-file-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>
          <path d="M14 2v6h6" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="uploaded-file-info">
        <div class="uploaded-file-name" [title]="course.courseThumbnailName">{{ course.courseThumbnailName }}</div>
        <div class="uploaded-file-meta">
          <span class="upload-success-badge">
            <svg viewBox="0 0 16 16" width="12" height="12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M3.5 8.5l3 3 6-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Uploaded
          </span>
        </div>
      </div>
      <div class="uploaded-file-actions">
        <button type="button" class="file-action-btn" (click)="downloadFile()" title="Download">
          <img src="assets/filelinkicon.svg" class="materialdownloadfile" alt="Download">
        </button>
        <button type="button" class="file-action-btn" (click)="removeCourseThumbnailImage()" title="Remove">
          <img src="assets/trash.svg" class="materialdeletefile" alt="Remove">
        </button>
      </div>
    </div>
  }
</div>

@if (isSubmitted && course.courseThumbnailFileId == 0) {
  <mat-error>Course Thumbnail is required</mat-error>
}

<div class="mb-10"></div>

<div>
  Status
  <div class="toggle">
    @for (cs of courseStatus; track cs) {
      <div class="switch-div">
        <input type="radio" [value]="cs.key" [name]="cs.value" [id]="cs.key" [className]="cs.value.toLowerCase()"
          (change)="statusChange()" [(ngModel)]="course.courseStatus" />
          <label for="{{cs.key}}">{{cs.value}}</label>
        </div>
      }
    </div>
    @if (isSubmitted && course.courseStatus == 0 ) {
      <mat-error>Status is required</mat-error>
    }
  </div>

  <div class="mb-10"></div>

  <div id="replacementdiv" [hidden]="!showReplacementDiv">
    <fieldset>
      <label id="intake-form-meeting-attendee-label">
        Select replacement for retired material, or choose to retire without a replacement
      </label>
      <div class="form-section-validator-controls w-10p0">
        <mat-radio-group name="radMeetingAttendeesGroupsection1" aria-labelledby="intake-form-meeting-attendee-label"
          [(ngModel)]="replacementRadioValue" (change)="replacementRadioChange()">
          <!-- #meetingAttendees="ngModel" required -->
          <mat-radio-button name="radioMeetingAttendee1section1" class="intake-form-radio-button display-vertical"
            value="1">
            Retire with Replacement
          </mat-radio-button>
          <mat-radio-button name="radioMeetingAttendee2section1" class="intake-form-radio-button" value="2" checked>
            Retire without Replacement
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </fieldset>
  </div>
  <div class="h-30"></div>
  <div [hidden]="!showReplacementFileSelector">
    <mat-form-field appearance="outline" floatLabel="always" class="w-10p0">
      <mat-label>Replacement Course</mat-label>
      <input type="text" placeholder="Select Replacement Course" matInput [matAutocomplete]="auto"
        name="replacementCourse" [(ngModel)]="selectedCourse" (ngModelChange)="updateCourseFiltering()"
        #username="ngModel" ng-MinLength="1">
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
          @for (course of filteredOptions | async; track course) {
            <mat-option [value]="course">
              {{course.courseName}}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>
  </form>
  <div class="mb-10"></div>
